import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { currencyString } from "@qgiv/core-js";
import { getFormattedPrice } from "@qgiv/core-donor";
import { findProductFromProductId } from "@qgiv/p2p-registration";
import { selectSpecificFormSetting } from "../../../../../redux/slices/formSettingsSlice";
import { selectAllProducts } from "../../../../../redux/slices/productsSlice";
import { selectAllRegistration } from "../../../../../redux/slices/registrationSlice";
import { selectRegistrationFeeDisplaySettings } from "../../../../../redux/slices/p2pSettingsSlice";
import StoreItemSummaryPrice from "./StoreItemSummaryPrice";

const ConnectedStoreItemSummaryPrice = ({ productId, storeCartIndex }) => {
    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const products = useSelector(selectAllProducts);
    const { storeCart } = useSelector(selectAllRegistration);
    const { Product_Quantity, Field_Data_Id } = storeCart[storeCartIndex];
    const { registrationFeeDisplay, registrationFeeDisplayText } = useSelector(
        selectRegistrationFeeDisplaySettings,
    );

    const currentProduct = findProductFromProductId(productId, products);

    const {
        fieldData = {},
        hasAttributes = false,
        price_fixed = undefined,
    } = currentProduct;

    const currentProductCost =
        hasAttributes && !price_fixed
            ? fieldData[Field_Data_Id].cost
            : price_fixed;

    const hasMultipleStoreItems = Number(Product_Quantity) > 1;
    const isFree = currentProductCost === 0;

    const formattedSingleItemPrice = getFormattedPrice(
        currentProductCost,
        currency,
        registrationFeeDisplay,
        registrationFeeDisplayText,
    );

    const formattedQuantityTotalPrice =
        // eslint-disable-next-line no-nested-ternary
        hasMultipleStoreItems && !isFree
            ? currencyString(
                  Number(currentProductCost) * Number(Product_Quantity),
                  currency,
              )
            : hasMultipleStoreItems && isFree
              ? formattedSingleItemPrice
              : "";

    const isVisible = true;
    const storeItemSummaryPriceProps = {
        formattedQuantityTotalPrice,
        formattedSingleItemPrice,
        hasMultipleStoreItems,
        isVisible,
    };

    return <StoreItemSummaryPrice {...storeItemSummaryPriceProps} />;
};

ConnectedStoreItemSummaryPrice.propTypes = {
    productId: PropTypes.number.isRequired,
    storeCartIndex: PropTypes.number.isRequired,
};

export default ConnectedStoreItemSummaryPrice;
